import { getCacheKey } from ".";

const CACHE: Record<string, Intl.ListFormat> = {};

export interface Options extends Intl.ListFormatOptions {
  locale?: string;
}

export function listFormatter(
  list: string[],
  {
    locale = "en",
    style = "long",
    type = "conjunction",
    ...publicOptions
  }: Options = {},
) {
  const options = { style, type, ...publicOptions };
  const cacheKey = getCacheKey(locale, options);

  if (!CACHE[cacheKey]) {
    CACHE[cacheKey] = new Intl.ListFormat(locale, options);
  }

  try {
    return CACHE[cacheKey].format(list);
  } catch (error) {
    return list.join(", ");
  }
}
